import { createContext, useContext, useState } from 'react'
import { MediaLightbox, MediaLightboxType } from 'src/components'
import { ArrivedFrom } from 'src/components/mediaLightbox/mediaLightbox.types'
import {
  MediaLightboxContextProps,
  MediaLightboxProps,
  MediaLightboxProviderProps,
  OnOpenLightboxParams
} from './mediaLightboxContext.types'

const MediaLightboxContext = createContext({} as MediaLightboxContextProps)

function setDefaultProps(): MediaLightboxProps {
  return {
    isOpen: false,
    arrivedFrom: '' as ArrivedFrom,
    postId: 0,
    commentId: 0,
    media: {
      type: MediaLightboxType.IMAGE,
      src: ''
    }
  }
}

export const MediaLightboxProvider = ({ children }: MediaLightboxProviderProps) => {
  const [lightboxProps, setLightboxProps] = useState<MediaLightboxProps>(setDefaultProps)

  function onOpenLightbox({
    src = '',
    type,
    provider,
    arrivedFrom,
    postId,
    commentId
  }: OnOpenLightboxParams) {
    setLightboxProps({
      isOpen: true,
      arrivedFrom,
      postId,
      commentId,
      media: {
        type,
        provider,
        src
      }
    })
  }

  function onCloseLightbox() {
    setLightboxProps((prevState) => ({
      ...prevState,
      isOpen: false
    }))

    setTimeout(() => {
      setLightboxProps(setDefaultProps)
    }, 500)
  }

  return (
    <MediaLightboxContext.Provider
      value={{ isOpen: lightboxProps.isOpen, onOpenLightbox, onCloseLightbox }}
    >
      {children}
      <MediaLightbox {...lightboxProps} onClose={onCloseLightbox} />
    </MediaLightboxContext.Provider>
  )
}

export const useMediaLightbox = () => {
  const context = useContext(MediaLightboxContext)

  if (!Object.keys(context).length) {
    throw new Error('useMediaLightbox must be used within a MediaLightboxContext')
  }

  return context
}
